import logger from 'shared/services/logger'
import { parseUrl } from 'query-string'

import { CSRF_FIELD_NAME } from 'shared/consts/httpHeaders'

import buildClientAPI from 'views/providers/clientAPI'
import store from 'shared/store'
import { setUserSession } from 'shared/store/ducks/userSession'
import { updatePageProperties } from 'shared/store/ducks/publicRuntimeConfig'

import { ROUTES_WITHOUT_SESSION_FETCHING } from 'shared/consts'

export const shouldFetchUserSession = currentPath =>
  !ROUTES_WITHOUT_SESSION_FETCHING.some(route =>
    currentPath.split('/').includes(route)
  )

const fetchUserSession = queryStr => {
  if (!shouldFetchUserSession(window.location.pathname)) {
    logger.warn(`Session fetching disabled for ${window.location.pathname}`)
    // Dispatching an empty session
    // so modules who expect user resolution can still work (crossSell, etc)
    store.dispatch(setUserSession({}))
    return
  }

  let params = {}

  const { query } = parseUrl(queryStr || window.location.search)

  if (query.expa && query.expa !== '') {
    params.expa = query.expa
  }

  const {
    pageProperties: { pzn }
  } = store.getPublicRuntimeConfig()

  if (pzn) {
    params.pzn = pzn
  }

  if (window.STORYBOOK_ENV) {
    params = null
  }

  const { clientFockService } = buildClientAPI()

  // TODO: use the fire/listen Event (used for crosssell)
  clientFockService
    .fetchUserSessionData({ params })
    .then(response => {
      const { data, headers: { [CSRF_FIELD_NAME]: csrfToken } = {} } = response
      // new way of doing it
      // needs to be added to components via connect
      // dispatch `updatePageProperties` first
      // b/c leads to re-render component with the wrong state
      store.dispatch(updatePageProperties({ csrfToken }))
      store.dispatch(setUserSession(data))
    })
    .catch(error => {
      logger.error(`UserSessionData not fetched: ${error}`)
      store.dispatch(setUserSession({}))
    })
    .finally(() => {
      if (params?.expa) {
        // params could be null during testing
        fetch(`/expa?expa=${params.expa}`, {
          method: 'POST'
        })
      }
    })
}

export default fetchUserSession
